import * as React from 'react';

import classnames from 'classnames';

import {colors} from '../colors/colors';
import {StackLegacy} from '../layout/stack/stack-legacy';
import type {SavedSettingToastState} from '../saved-setting-toast/saved-setting-toast';

import {renderHeader} from './helpers';

export type MarginTopValue = 0 | 2 | 4 | 8 | 16 | 24 | 32;
export type GapValue = 0 | 2 | 4 | 6 | 8 | 12 | 16 | 24 | 32 | 48;

type Props = {
    icon: React.ComponentType<any>;
    children: React.ReactNode;
    header?: string;
    headerButton?: React.ReactNode;
    gap?: GapValue;
    iconColor?: string;
    fullWidth?: boolean;
    marginTopValue?: MarginTopValue;
    saveState?: SavedSettingToastState;
    setSaveState?: (newState: SavedSettingToastState) => void;
};

export function IconSection(props: Props) {
    const {iconColor = colors.greyLt, marginTopValue = 8, fullWidth = false, gap = 12} = props;
    const IconComponent = props.icon;

    const iconClassNames = classnames({
        [`mt-${marginTopValue}`]: marginTopValue,
    });

    const childrenClassNames = classnames({
        'full-width': fullWidth,
    });

    const containerClassNames = classnames('flex full-width', {
        [`gap-${gap}`]: gap,
    });

    return (
        <div className={containerClassNames}>
            <div className={iconClassNames}>
                <IconComponent size={20} fill={iconColor} alignCenter={true} />
            </div>
            <StackLegacy spacing={8} isFullWidth={fullWidth}>
                {renderHeader(
                    props.header,
                    props.headerButton,
                    props.saveState,
                    props.setSaveState
                )}
                <div className={childrenClassNames}>{props.children}</div>
            </StackLegacy>
        </div>
    );
}
